import * as React from 'react';
import PropTypes from 'prop-types';
import { RepricingInfoProvider, AnalyticsDataListener } from '@edreamsodigeo/frontend-price-freeze';
import PriceFreezeFunnelProvider from './Provider';
import { Suspense } from 'react';
export default function Container({
  children
}) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(PriceFreezeFunnelProvider, null, /*#__PURE__*/React.createElement(AnalyticsDataListener, null), /*#__PURE__*/React.createElement(RepricingInfoProvider, null, children)));
}
Container.propTypes = {
  children: PropTypes.node.isRequired
};